import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Status, SuccessCircleTickGraphic } from "@mwi/ui";
import { clearChangePasswordStep } from "slices/auth";
import { RootState } from "store";
import UserRole from "enums/UserRole";

const ChangePasswordStep3 = ({
  onDone,
}: {
  onDone?: () => void;
}): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.auth.user);

  const handleOnClick = () => {
    user?.role === UserRole.PRACTICE_ADMIN || user?.role === UserRole.MWI_ADMIN
      ? navigate("/admin/account")
      : navigate("/settings/account");
    dispatch(clearChangePasswordStep());
    if (onDone) {
      onDone();
    }
  };

  return (
    <div className="flex flex-col flex-grow">
      <div className="flex max-w-[344px] w-full mx-auto flex-grow">
        <Status
          onClick={handleOnClick}
          title="Your password has been changed"
          primaryLinkText="Go back to your account"
          graphic={<SuccessCircleTickGraphic className="text-primary" />}
        />
      </div>
    </div>
  );
};

export default ChangePasswordStep3;
